/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Breadcrumbs } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';
import type { DomainFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

import _t from 'i18n!nls/xdp';

type Props = {
  domains?: Array<DomainFragment> | null;
  programSlug: string;
};

const EnterpriseBreadcrumbs = ({ domains, programSlug }: Props) => {
  const eventingProductData = useEventingProductData();
  const track = useTracker();
  const onClickBreadcrumbItem = (linkName: string) => () => {
    track('click_button', {
      button: { name: 'description_page_breadcrumb', linkName },
      ...eventingProductData,
    });
  };

  return (
    <Breadcrumbs>
      <Breadcrumbs.Item href={`/programs/${programSlug}`} onClick={onClickBreadcrumbItem('homepage')}>
        {_t('Home')}
      </Breadcrumbs.Item>
      {domains && domains.length > 0 && (
        <Breadcrumbs.Item
          href={`/programs/${programSlug}/${domains[0].domainId}`}
          onClick={onClickBreadcrumbItem('domain')}
        >
          {domains[0].domainName}
        </Breadcrumbs.Item>
      )}
      {domains && domains.length > 0 && domains[0].subdomainId && domains[0].subdomainName && (
        <Breadcrumbs.Item
          href={`/programs/${programSlug}/${domains[0].domainId}/${domains[0].subdomainId}`}
          onClick={onClickBreadcrumbItem('subdomain')}
        >
          {domains[0].subdomainName}
        </Breadcrumbs.Item>
      )}
    </Breadcrumbs>
  );
};

export default EnterpriseBreadcrumbs;
